import { getCookieData } from '@repo/common-utils';
import { useAuthContext } from '@repo/user-session';
import { Button, Description } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { CHECK_DECISION_ACTION_CODE_COOKIE_KEY } from '@/components/tax-refund/common/data/result-refund-data';
import { AUTH_PATHS, COMMON_PATHS, 환급결정확인알림톡_PATH } from '@/lib/constants/paths';
import useSaveRefundActionLog from '@/lib/hooks/api/mutation/use-save-refund-action-log';
import { useBizMessageRequestType } from '@/lib/hooks/use-biz-message-request-type';
import useDetectOs from '@/lib/hooks/use-detect-os';

const TrrStartContent = () => {
  const router = useRouter();
  const { requestType } = useBizMessageRequestType();
  const detectOS = useDetectOs();
  const { auth, setIsAllowAuthGuard } = useAuthContext();
  const { commit: saveActionLog } = useSaveRefundActionLog();
  const sendLog = useRef(false);

  const isShowLoginGuide = auth.status === 'logout';
  const hometaxStartTime = requestType === 'recollect' ? 9 : 6;
  const isAvailableTime = new Date().getHours() >= hometaxStartTime;
  const description = {
    recollect: '신고 자료 진행이 어려워요.',
    checkDecision: '홈택스 점검으로 환급 결과 확인이 어려워요.',
    job_retention: '홈택스 점검으로 환급 결과 확인이 어려워요.'
  };

  useEffect(() => {
    if (!isShowLoginGuide && isAvailableTime && detectOS !== 'unset') {
      setIsAllowAuthGuard(false);
      const actionCode = router.query.actionCode ?? getCookieData(CHECK_DECISION_ACTION_CODE_COOKIE_KEY);
      if (actionCode && !sendLog.current) {
        saveActionLog({ variables: { actionCode, actionStatus: '로그인' } });
        sendLog.current = true;
      }
      if (detectOS === 'windows') {
        router.push({
          pathname: 환급결정확인알림톡_PATH.결정확인방법선택,
          query: router.query
        });
      } else {
        router.push({
          pathname: COMMON_PATHS.간편인증_정보입력,
          query: Object.assign({}, router.query, {
            from: 'alimtalk'
          })
        });
      }
    }
  }, [isShowLoginGuide, isAvailableTime, detectOS, saveActionLog, router, setIsAllowAuthGuard]);

  const handleLogin = () => {
    router.push({
      pathname: `${AUTH_PATHS.로그인}`,
      query: router.query
    });
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center pb-[108px]">
      {isShowLoginGuide && (
        <Description>
          <Description.Guide
            subTitle={'서비스 이용을 위해\n로그인을 해주세요'}
            description={'유효시간이 지나 로그인이 필요해요.'}
            imgChild={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark-dimmed_sm.svg`} className={'w-20'} alt={''} />
            }
          />
          <Button.Box state="primary" size="large" onClick={handleLogin}>
            로그인
          </Button.Box>
        </Description>
      )}
      {!isShowLoginGuide && !isAvailableTime && (
        <Description>
          <Description.Guide
            subTitle={`아침 ${hometaxStartTime}시 이후에 다시 조회해주세요`}
            description={`매일 밤 0시부터 아침 ${hometaxStartTime}시까지는\n${description[requestType]}`}
            imgChild={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark-dimmed_sm.svg`} className={'w-20'} alt={''} />
            }
          />
        </Description>
      )}
    </div>
  );
};

export default TrrStartContent;
